import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconCopyOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="m16.875 0 4.863 5.409V19.2l-4.8-.001V24H2V4.8h4.8V0zm-5.763 5.922H3.204v16.903h12.61l.001-11.907h-4.703zm4.8-4.8h-7.99V4.8h4.153l4.863 5.409v7.868h3.677V6.119h-4.703zm-3.678 5.271v3.697h3.03zm4.8-4.8V5.29h3.03z" /></svg>
);
